
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 2343"}},[_c('g',{attrs:{"data-name":"Group 1971"}},[_c('g',{attrs:{"data-name":"weapons (1)","opacity":".2"}},[_c('path',{attrs:{"data-name":"Path 94","d":"M19.505 2.854L10.2.03a.687.687 0 00-.4 0L.495 2.854a.7.7 0 00-.5.673v10.356a6.733 6.733 0 001.6 4.1 16.636 16.636 0 003.338 3.128 29.861 29.861 0 004.776 2.83.688.688 0 00.568 0 29.861 29.861 0 004.776-2.83 16.64 16.64 0 003.338-3.128 6.734 6.734 0 001.6-4.1V3.527a.7.7 0 00-.486-.673z","fill":"#42ddb3"}})])]),_c('g',{attrs:{"data-name":"Group 2342"}},[_c('path',{attrs:{"data-name":"Path 1651","d":"M10 5a3.493 3.493 0 00-3.467 3.51v2a.094.094 0 01-.05.069c-.187.063-.34.118-.479.173a.486.486 0 00-.292.434V15.8a.489.489 0 00.29.434 10.726 10.726 0 007.995 0 .489.489 0 00.29-.434v-4.61a.486.486 0 00-.292-.434 12.467 12.467 0 00-.479-.173.094.094 0 01-.05-.069v-2A3.493 3.493 0 0010 5zm-.944 7.593a.944.944 0 111.416.81v1.58a.472.472 0 11-.944 0V13.4a.944.944 0 01-.472-.807zm3.219-4.083v1.73a10.69 10.69 0 00-4.55 0V8.51a2.275 2.275 0 114.55 0z","fill":"#42ddb3"}})])])])
          )
        }
      }
    